<template>
  <div class="icon-page">
    <h1>icon</h1>
    <span class="iconfont icon-base icon-sort-up-full"></span>
    <span class="iconfont icon-base icon-sort-down-full"></span>
    <span class="iconfont icon-base icon-jindou"></span>
    <span class="iconfont icon-base icon-gengduo1"></span>
    <span class="iconfont icon-base icon-shafa"></span>
    <span class="iconfont icon-base icon-yinliao"></span>
    <span class="iconfont icon-base icon-muying-naiping"></span>
    <span class="iconfont icon-base icon-gengduo"></span>
    <span class="iconfont icon-base icon-tishi"></span>
    <span class="iconfont icon-base icon-aixin_shixin"></span>
    <span class="iconfont icon-base icon-icon-10"></span>
    <span class="iconfont icon-base icon-icon-7"></span>
    <span class="iconfont icon-base icon-icon-9"></span>
    <span class="iconfont icon-base icon-icon-8"></span>
    <span class="iconfont icon-base icon-fenxiang"></span>
    <span class="iconfont icon-base icon-kefu"></span>
    <span class="iconfont icon-base icon-gouwuche1"></span>
    <span class="iconfont icon-base icon-wenhao"></span>
    <span class="iconfont icon-base icon-wuliu"></span>
    <span class="iconfont icon-base icon-dingdan1"></span>
    <span class="iconfont icon-base icon-tui"></span>
    <span class="iconfont icon-base icon-yijian"></span>
    <span class="iconfont icon-base icon-dianying"></span>
    <span class="iconfont icon-base icon-show_yinsizhengce_fill"></span>
    <span class="iconfont icon-base icon-yonghuxieyi"></span>
    <span class="iconfont icon-base icon-mimaffffffpx"></span>
    <span class="iconfont icon-base icon-dizhi"></span>
    <span class="iconfont icon-base icon-changjianwenti-mianxing"></span>
    <span class="iconfont icon-base icon-jiankangshuju"></span>
    <span class="iconfont icon-base icon-lvyou"></span>
    <span class="iconfont icon-base icon-yanchu"></span>
    <span class="iconfont icon-base icon-mendian"></span>
    <span class="iconfont icon-base icon-icon-4"></span>
    <span class="iconfont icon-base icon-icon-1"></span>
    <span class="iconfont icon-base icon-icon-3"></span>
    <span class="iconfont icon-base icon-icon-6"></span>
    <span class="iconfont icon-base icon-icon-2"></span>
    <span class="iconfont icon-base icon-icon-5"></span>
    <span class="iconfont icon-base icon-home"></span>
    <span class="iconfont icon-base icon-wuliuqiache"></span>
    <span class="iconfont icon-base icon-yundonghuwaileimufill"></span>
    <span class="iconfont icon-base icon-dingdan"></span>
    <span class="iconfont icon-base icon-guanyuwomen"></span>
    <span class="iconfont icon-base icon-rexiaochanpin"></span>
    <span class="iconfont icon-base icon-youhuijuan-xianxing"></span>
    <span class="iconfont icon-base icon-youhuijuan"></span>
    <span class="iconfont icon-base icon-shouhou"></span>
    <span class="iconfont icon-base icon-jiadian"></span>
    <span class="iconfont icon-base icon-bangongyongpin"></span>
    <span class="iconfont icon-base icon-wuliupeisong-"></span>
    <span class="iconfont icon-base icon-dianyingpiao"></span>
    <span class="iconfont icon-base icon-dingdan-copy"></span>
    <span class="iconfont icon-base icon-shipin-shuiguo-pingguo"></span>
    <span class="iconfont icon-base icon-3"></span>
    <span class="iconfont icon-base icon-meizhuang"></span>
    <span class="iconfont icon-base icon-xihu"></span>
    <span class="iconfont icon-base icon-gongneng"></span>
    <span class="iconfont icon-base icon-shouhoupeixun"></span>
    <span class="iconfont icon-base icon-zhaopian"></span>
    <span class="iconfont icon-base icon-gouwuche"></span>
    <span class="iconfont icon-base icon-daohang"></span>
    <span class="iconfont icon-base icon-yiguanbi"></span>
    <span class="iconfont icon-base icon-kuaidi"></span>
    <span class="iconfont icon-base icon-tubiaozhizuomoban-"></span>
    <span class="iconfont icon-base icon-jiaoyin"></span>
    <span class="iconfont icon-base icon-jindou"></span>
    <span class="iconfont icon-base icon-gengduo1"></span>
    <span class="iconfont icon-base icon-shafa"></span>
    <span class="iconfont icon-base icon-yinliao"></span>
    <span class="iconfont icon-base icon-muying-naiping"></span>
    <span class="iconfont icon-base icon-gengduo"></span>
    <span class="iconfont icon-base icon-tishi"></span>
    <span class="iconfont icon-base icon-aixin_shixin"></span>
    <span class="iconfont icon-base icon-icon-10"></span>
    <span class="iconfont icon-base icon-icon-7"></span>
    <span class="iconfont icon-base icon-icon-9"></span>
    <span class="iconfont icon-base icon-icon-8"></span>
    <span class="iconfont icon-base icon-fenxiang"></span>
    <span class="iconfont icon-base icon-kefu"></span>
    <span class="iconfont icon-base icon-gouwuche1"></span>
    <span class="iconfont icon-base icon-wenhao"></span>
    <span class="iconfont icon-base icon-wuliu"></span>
    <span class="iconfont icon-base icon-dingdan1"></span>
    <span class="iconfont icon-base icon-tui"></span>
    <span class="iconfont icon-base icon-yijian"></span>
    <span class="iconfont icon-base icon-dianying"></span>
    <span class="iconfont icon-base icon-show_yinsizhengce_fill"></span>
    <span class="iconfont icon-base icon-yonghuxieyi"></span>
    <span class="iconfont icon-base icon-mimaffffffpx"></span>
    <span class="iconfont icon-base icon-dizhi"></span>
    <span class="iconfont icon-base icon-changjianwenti-mianxing"></span>
    <span class="iconfont icon-base icon-jiankangshuju"></span>
    <span class="iconfont icon-base icon-lvyou"></span>
    <span class="iconfont icon-base icon-yanchu"></span>
    <span class="iconfont icon-base icon-mendian"></span>
    <span class="iconfont icon-base icon-icon-4"></span>
    <span class="iconfont icon-base icon-icon-1"></span>
    <span class="iconfont icon-base icon-icon-3"></span>
    <span class="iconfont icon-base icon-icon-6"></span>
    <span class="iconfont icon-base icon-icon-2"></span>
    <span class="iconfont icon-base icon-icon-5"></span>
    <span class="iconfont icon-base icon-home"></span>
    <span class="iconfont icon-base icon-wuliuqiache"></span>
    <span class="iconfont icon-base icon-yundonghuwaileimufill"></span>
    <span class="iconfont icon-base icon-dingdan"></span>
    <span class="iconfont icon-base icon-guanyuwomen"></span>
    <span class="iconfont icon-base icon-rexiaochanpin"></span>
    <span class="iconfont icon-base icon-youhuijuan-xianxing"></span>
    <span class="iconfont icon-base icon-youhuijuan"></span>
    <span class="iconfont icon-base icon-shouhou"></span>
    <span class="iconfont icon-base icon-jiadian"></span>
    <span class="iconfont icon-base icon-bangongyongpin"></span>
    <span class="iconfont icon-base icon-wuliupeisong-"></span>
    <span class="iconfont icon-base icon-dianyingpiao"></span>
    <span class="iconfont icon-base icon-dingdan-copy"></span>
    <span class="iconfont icon-base icon-shipin-shuiguo-pingguo"></span>
    <span class="iconfont icon-base icon-3"></span>
    <span class="iconfont icon-base icon-meizhuang"></span>
    <span class="iconfont icon-base icon-xihu"></span>
    <span class="iconfont icon-base icon-gongneng"></span>
    <span class="iconfont icon-base icon-shouhoupeixun"></span>
    <span class="iconfont icon-base icon-zhaopian"></span>
    <span class="iconfont icon-base icon-gouwuche"></span>
    <span class="iconfont icon-base icon-daohang"></span>
    <span class="iconfont icon-base icon-yiguanbi"></span>
    <span class="iconfont icon-base icon-kuaidi"></span>
  </div>
</template>

<style>
.icon-page {
  overflow-wrap: break-word;
}

.icon-page .iconfont {
  font-size: 30px;
  padding: 15px;
}
</style>

<script>
export default {
}
</script>